import { ifSelectorExist } from "./utils";

export const loadMoreOffer = () => {
  let textContainers = document.querySelectorAll(".ip-offers__item__content__data");
  let maxHeight = 140;

  if (ifSelectorExist(textContainers)) {
    textContainers.forEach((item) => {
      let itemHeight = item.offsetHeight;

      if (itemHeight >= maxHeight) {
        let showMoreButton = document.createElement("button");
        showMoreButton.textContent = "VIEW MORE";
        showMoreButton.onclick = function () {
          item.classList.add("open");
          showMoreButton.remove();
        };

        item.appendChild(showMoreButton);
      }
    });
  }
};
